import { Box } from '@betterment/samba-react';

export function NavBackgroundScrim() {
  return (
    <Box
      css={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        bg: 'background.overlay',
        display: {
          base: 'block',
          xl: 'none',
        },
      }}
    />
  );
}
